<template>
  <div>
    <DynamicToggleCollapse
      :titles="[{id:'Geofence-filter',name:'Geofence filter'},{id:'Device-filter',name:'Device filter'}]">
      <b-collapse id="Device-filter">
        <b-card>
          <DevicesListFilters :haseSupportFilter="true" @divicesFilterd="divicesFilterd" @merageFilterWithRequest="merageFilterWithRequest" />
        </b-card>
      </b-collapse>

      <b-collapse id="Geofence-filter">
        <b-card>
          <GeofencesListFilters @geofencesFilterd="geofencesFilterd"
            @merageGeofencesFilterWithRequest="merageGeofencesFilterWithRequest" />
        </b-card>
      </b-collapse>
    </DynamicToggleCollapse>

    <!-- form report -->
    <b-card style="position: relative">

      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <b-form @submit.prevent="getReport" class="">

        <b-row class="mt-2">

          <!-- devices  -->
          <b-col cols="6">
            <b-form-group :label="$t('Devices')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.devices"
              :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{name: $t('all'), id: 'all'},...devices]"
                :reduce="d => d.id" />
              <small v-if="errors && ('devices' in errors)" class="text-danger">
                {{ $t(errors['devices'][0]) }}
              </small>
            </b-form-group>
          </b-col>


          <!-- geofence  -->
          <b-col cols="6">
            <b-form-group :label="$t('Geofence')">
              <v-select multiple :close-on-select="false" v-model="request.geofences"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                
                 :getOptionLabel="d => d.name"
               
                :options="[{name:$t('all'), id: 'all'},...geofences]" :reduce="d => d.id" />
              <small v-if="errors && ('geofences' in errors)" class="text-danger">
                {{ $t(errors['geofences'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col v-if="report_type=='report'" md="12" sm="12">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder="YYYY-MM-DD" />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{('from' in errors) ? errors['from'][0] : '' }}
                {{('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>


         


        </b-row>
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col v-if="report_type=='report'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>

          <b-col v-if="report_type=='setting'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button" variant="primary" class="mr-1"
              @click="saveDialySetting('supportDevices')">
              {{ $t('Save Setings') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <div v-if="report_data">
      <DataTable :report_data="report_data" :report_fields="report_fields"
        :filter_included_fields="filter_included_fields" :request="request" :errors="errors" :loading="dataTableloading||loading"
        :getReport="getReport" :total="total" :from="from" :to="to"  :sortData="sortData"  />

    </div>


  </div>
</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, BCollapse
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, onMounted } from '@vue/composition-api'

import {
  createFrame, createjsPDFInstance, createTable
} from '@/share/reports/pdfCommonFunctions'

import reportForm from '@/app/reports/geofence/reportForm'
import supportCenterLogic from '@/app/reports/supportCenter/logic'


import DevicesListFilters from '../filters/DevicesListFilters.vue'
import FilterLogic from '@/views/reports/filters/filterLogic.js'

// import GeofencesListFilters from '@/views/reports/filters/supportCenter/GeofencesListFilters.vue'
// import GeofenceFilterLogic from '@/views/reports/filters/supportCenter/filterLogic.js'

import GeofencesListFilters from '@/views/reports/filters/geofences/GeofencesListFilters.vue'
import GeofenceFilterLogic from '@/views/reports/filters/geofences/filterLogic.js'

import DynamicToggleCollapse from '@/views/ui/toggle-collapse/DynamicToggleCollapse.vue'

import { ReportSetting } from '@/views/reports/ReportSettings'
import DataTable from '@/views/reports/data-table/DataTable.vue'

import  ReportOptions from  '@/views/reports/components/options.js'
export default {
  name: 'SupportCenterReport',
  components: {
    BRow, BCard, BFormCheckboxGroup, BTable, BPagination, BCollapse,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert, BFormGroup, BFormInput, flatPickr,
    BFormCheckbox, BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    DevicesListFilters,
    DynamicToggleCollapse,
    GeofencesListFilters,
    DataTable

  },
  directives: { Ripple, },
  props: {
    report_type: {
      type: String,
      default: 'report'

    }
  },
  setup(props, { root }) {
    const geofencesFilterd = (data) => {
      geofences.value = data;
    }

    const divicesFilterd = (data) => {
      devices.value = data;
    }
    const merageFilterWithRequest = (data) => {
     
        delete data['type']
      if(data['isSupport']=="all"){
        delete data['isSupport']
        delete request.value.isSupport
        
      }

      Object.assign(request.value, data);
    }

    const merageGeofencesFilterWithRequest = (data) => {
      delete data['type']

      Object.assign(request.value, data);
    }
    const { geofences } = GeofenceFilterLogic()

    const rangeDate = ref('')
    const tableRef = ref(null)

    const { type } = reportForm()


    
    const { report_data, request, errors, loading, getReport, getReportForPdf, total, from, to,isSortDirDesc,sortBy,dataTableloading } = supportCenterLogic()
   
    const sortData=(data)=>{
      sortBy.value=data.sortBy
      isSortDirDesc.value=data.isSortDirDesc
    }

    const { devices, filter_request } = FilterLogic()
    const {pickerOptions} =ReportOptions(request.value)

    const filter_included_fields = ['day', 'device', 'area', 'count', 'distances', 'totalDistance', 'enterExitTimes', 'durations', 'totalDurations']

    const report_fields = [
      {
        key: 'index',
        label: 'id',
       
      },
      {
        key: 'owner',
        label: 'owner',
        sortable: false
      },
      {
        key: 'contract',
        label:'contract',
        sortable: false
      },
      {
        key: 'device',
        label:'device',
        sortable: false
      },
      {
        key: 'geofence',
        label:'geofence',
        sortable: false
      },
      {
        key: 'time',
        label: 'time',
        sortable: false
      },
      {
        key: 'distance',
        label: 'distance',
        sortable: false
      },
      {
        key: 'enterTime',
        label: 'Enter Time',
        sortable: false
      },

     

      {
        key: 'exitTime',
        label: 'Exit Time',
        sortable: false
      },
     
     
    ]

   

    /// here use this form ass dialy report setting
    const toaster = (msg, variant = 'success', title = 'Success') => {
      root.$root.$bvToast.toast(
        root.$i18n.t(msg), {
        title: root.$i18n.t(title),
        variant,
        solid: true,
      })
    }
    const saveDialySetting = (reportName) => {
      let setting_data = request.value;
      delete setting_data.to;
      delete setting_data.from;
      // let insideOldVal = setting_data.inside;
      // setting_data.inside = `${insideOldVal}`

      console.log(setting_data)

      ReportSetting.setSettings(reportName, setting_data).then((res) => {
        toaster('settigs saved succeffly!!', 'success!!')
      }).catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
    }
    onMounted(() => {

      if (props.report_type == "setting") {
        ReportSetting.getSetting('geofence').then((res) => {

          request.value = res;
        })
      }
    })
    //here end of   dialy report setting
    return {
      report_data, report_fields, filter_included_fields, total, from, to, rangeDate,
      tableRef,
      getReport,


      devices,
      geofences,
      type,

      pickerOptions,


      request,
      loading,
      errors,
      filter_request,
      divicesFilterd,
      merageFilterWithRequest
      , geofencesFilterd
      , merageGeofencesFilterWithRequest
      //here dialy report settings
      , saveDialySetting
      ,sortData
      ,dataTableloading
    }

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
.group-row {
  background-color: #ddd;
}
</style>
